import React from "react"

import Header from "../component/Auth/Header";
import Signup from "../component/Auth/Signup";

export default function SignupPage(){
    return(
        <div className="relative top-10  w-[max-content] p-4 flex justify-between m-auto " >
             <div className="w-[30rem] m-auto bg-[#D4C1A7] p-12 rounded-[20px]  mb-20 mt-8 max-[768px]:w-[25rem] h-[fit-content] ">
            <Header
              heading="Signup to create an account"
              paragraph="Already have an account? "
              linkName="Login"
              linkUrl="/login"
            />
            <Signup/>
            </div>
        </div>
    )
}